export var SENTINEL_1_TRANSFER_PERMISSIONS = ['sentinel.ach.incoming.initiate', 'sentinel.ach.outgoing.initiate', 'sentinel.ira_transfer_validation.read'];
export var SENTINEL_2_TRANSFER_PERMISSIONS = ['cash_transfer.UI.navigation.view', 'account.read'];

// Permissions are pulled from confluence doc: https://confluence.apexclearing.local/display/ENG/Legit+Permissions+used+by+UIs
export var ACATS_PERMISSIONS = ['alps.read'];
export var FRACTIONAL_TRADING_PERMISSIONS = ['comet.admin.write'];
export var LEGIT_PERMISSIONS = ['legit.parties.list'];
export var SENTINEL_2_PERMISSIONS = ['sentinel.view'];
export var SKETCH_PERMISSIONS = ['sketch.config.identity_validation.read'];
export var BRAGGART_PERMISSIONS = ['braggart_support.view'];
export var TRADE_PROCESSING_PERMISSIONS = ['trade_reports.read'];
export var MENU_PERMISSIONS = [].concat(SENTINEL_1_TRANSFER_PERMISSIONS, SENTINEL_2_TRANSFER_PERMISSIONS, ACATS_PERMISSIONS, FRACTIONAL_TRADING_PERMISSIONS, LEGIT_PERMISSIONS, SENTINEL_2_PERMISSIONS, SKETCH_PERMISSIONS, BRAGGART_PERMISSIONS, TRADE_PROCESSING_PERMISSIONS);
export var NEW_TOOLS_COLUMNS = ['Apex Accounts', 'Correspondent'];
export var NEW_TOOLS_SECOND_COLUMNS = ['Cashiering', 'Trades', 'Admin'];
export var NEW_TOOLS_LINKS = [{
  key: 'AccountSummary',
  label: 'Account Summary',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: ''
}, {
  key: 'CustomerInfo',
  label: 'Account Details',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/customer'
}, {
  key: 'Positions',
  label: 'Positions',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/positions'
}, {
  key: 'Activity',
  label: 'Activity',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/activity'
}, {
  key: 'Balances',
  label: 'Balances',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/balances'
}, {
  key: 'AchRelationships',
  label: 'ACH Relationships',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/ach_relationship'
}, {
  key: 'AchTransfers',
  label: 'ACH Transfers',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/ach_relationship'
}, {
  key: 'CostBasis',
  label: 'Cost Basis',
  parentHeader: 'Apex Accounts',
  href: '/accounts/#',
  pageHref: '/cost_basis'
}, {
  key: 'Activities',
  label: 'Activities',
  parentHeader: 'Correspondent',
  href: '/correspondent/#/activities',
  pageHref: ''
}, {
  key: 'Acats',
  label: 'Account Transfers',
  parentHeader: 'Correspondent',
  href: '/account-transfers',
  pageHref: ''
}, {
  key: 'FullyPaid',
  label: 'Fully Paid',
  parentHeader: 'Correspondent',
  href: '/fullypaid',
  pageHref: ''
}, {
  key: 'Sketch',
  label: 'Sketch',
  parentHeader: 'Correspondent',
  href: '/sketch',
  pageHref: ''
}, {
  key: 'Sentinel2',
  label: 'Transfer Processing',
  parentHeader: 'Cashiering',
  href: '/cashiering/search',
  pageHref: ''
}, {
  key: 'TradeProcessing',
  label: 'Trade Processing',
  parentHeader: 'Trades',
  href: '/tradeprocessing',
  pageHref: '/trade-entry'
}, {
  key: 'Legit',
  label: 'Legit',
  parentHeader: 'Admin',
  href: '/legit',
  pageHref: ''
}, {
  key: 'BraggartSupport',
  label: 'Braggart Support',
  parentHeader: 'Admin',
  href: '/support',
  pageHref: ''
}, {
  key: 'FractionalTrading',
  label: 'Fractional Trading',
  parentHeader: 'Admin',
  href: '/fractional-trading',
  pageHref: '/tradingLimit'
}];

export var ACCOUNTS_V2_URL = '/accountsV2';
export var ACCOUNTS_V2_TRANSFERS_URL = function ACCOUNTS_V2_TRANSFERS_URL(accountNumber) {
  return ACCOUNTS_V2_URL + '/transfers/' + accountNumber;
};